import { useParams } from "react-router-dom";
import { Card, Spinner, Title } from "components/common";
import PageLayout from "components/common/pageLayout/pageLayout";
import { TagsWithPlus } from "components/custom";
import QuestionItem from "components/custom/questions/questionItem";
import { renderQuillHtml } from "configs/utils";
import { useGetImportedQuestionQuery } from "features/importedQuestions/apis";

const ViewImportedQuestion = () => {
  const params = useParams();
  const {
    data: questionResponse,
    isLoading,
    error,
  } = useGetImportedQuestionQuery(
    { id: params?.id },
    { skip: !params?.id, refetchOnMountOrArgChange: true }
  );

  const question =
    questionResponse?.data || questionResponse?.[0] || questionResponse;
  const specialties = question?.speciality?.length
    ? question.speciality
        .map((item) => item?.name || item?.topic)
        .filter(Boolean)
    : ["-"];
  const topics =
    question?.topics?.length && question.topics.every(Boolean)
      ? question.topics
      : ["-"];

  return (
    <PageLayout>
      {isLoading ? (
        <Spinner />
      ) : error ? (
        "Error"
      ) : (
        <Card style={{ minHeight: "88vh", overflow: "auto" }}>
          {renderQuillHtml(
            `<p>
              <span style="font-weight: bold; font-size: 18px;">Question:</span>
              <span style="display: inline;">${question?.description || ""}</span>
            </p>`,
            undefined,
            {
              margin: "-10px 0px -10px -10px",
            }
          )}
          <QuestionItem question={question} />
          <div style={{ marginLeft: "1%" }}>
            <div style={{ display: "flex", gap: "10px" }}>
              <Title level={3}>Specialities:</Title>
              <TagsWithPlus data={specialties} plusAfter={5} />
            </div>
            <div style={{ display: "flex", gap: "10px" }}>
              <Title level={3}>Topics:</Title>
              <TagsWithPlus data={topics} plusAfter={5} />
            </div>
          </div>
        </Card>
      )}
    </PageLayout>
  );
};

export default ViewImportedQuestion;
